module.exports = __webpack_public_path__ + "static/media/HTTTN-CM-1-BG-1920x1080-text.0fb9f585.png";